module.exports = __webpack_public_path__ + "img/pair-process.eadecc6b.gif";